import axios from 'axios'
const local = process.env.REACT_APP_SERVER_URL;

// Safari detection utility
const isSafari = () => {
    const userAgent = navigator.userAgent;
    return /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
};

const api = axios.create({
    baseURL: `${local}/api`,
    withCredentials : true
})

// Request interceptor to add Authorization header for Safari
api.interceptors.request.use(
    (config) => {
        // Check if we have a stored token for authorization header fallback
        const authToken = localStorage.getItem('authToken') || localStorage.getItem('customerToken');
        
        // For Safari, always add Authorization header if we have a token
        if (isSafari() && authToken) {
            config.headers.Authorization = `Bearer ${authToken}`;
        }
        // For production, also add Authorization header as fallback if cookies might not work
        else if (authToken && process.env.NODE_ENV === 'production') {
            config.headers.Authorization = `Bearer ${authToken}`;
        }
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle auth errors and cleanup Safari tokens
api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        
        // If it's a token expired error and we haven't already tried to refresh
        if (error.response?.status === 409 && 
            (error.response?.data?.code === 'TOKEN_EXPIRED' || 
             error.response?.data?.error === 'Token expired, please login again') &&
            !originalRequest._retry) {
            
            originalRequest._retry = true;
            
            try {
                // Try to refresh the customer token
                console.log('Customer token expired, attempting refresh...');
                const refreshResponse = await api.post('/customer/refresh-token');
                
                if (refreshResponse.data.token) {
                    // Update stored tokens
                    localStorage.setItem('customerToken', refreshResponse.data.token);
                    
                    // For Safari users, also update authToken
                    if (refreshResponse.data.isSafari && refreshResponse.data.cookieFallback) {
                        localStorage.setItem('authToken', refreshResponse.data.token);
                    }
                    
                    console.log('Customer token refreshed successfully, retrying original request');
                    // Retry the original request
                    return api(originalRequest);
                }
            } catch (refreshError) {
                console.log('Customer token refresh failed, cleaning up tokens');
                // If refresh fails, clean up tokens and let the app handle redirect to login
                localStorage.removeItem('authToken');
                localStorage.removeItem('isSafariAuth');
                localStorage.removeItem('customerToken');
                return Promise.reject(refreshError);
            }
        }
        
        // If it's an auth error and we can't refresh, clean up tokens
        if (error.response?.status === 409 && 
            (error.response?.data?.code === 'NO_TOKEN' || 
             error.response?.data?.code === 'INVALID_TOKEN' ||
             error.response?.data?.error === 'Please login first')) {
            
            localStorage.removeItem('authToken');
            localStorage.removeItem('isSafariAuth');
            localStorage.removeItem('customerToken');
        }
        
        return Promise.reject(error);
    }
);

export default api